import { c as _c } from "react/compiler-runtime";
interface PediatricsIconProps {
  size?: number;
  className?: string;
}
const PediatricsIcon = t0 => {
  const $ = _c(12);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t10;
  let t11;
  let t12;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M12.9475 17.6318C13.3949 18.2283 14.558 19.0634 15.6317 17.6318" stroke="currentColor" strokeWidth="1.16316" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M13.2746 10.0263L12.7907 10.3489L13.2746 10.0263ZM16.4791 9.83903C16.6227 9.55175 16.5063 9.20241 16.219 9.05877C15.9317 8.91512 15.5824 9.03157 15.4387 9.31886L15.9589 9.57895L16.4791 9.83903ZM14.6168 6L14.2535 5.54587C13.8029 5.90637 13.1922 6.65514 12.8052 7.49371C12.4273 8.31245 12.1732 9.42248 12.7907 10.3489L13.2746 10.0263L13.7585 9.70374C13.4883 9.29837 13.5325 8.69349 13.8613 7.98114C14.1809 7.28862 14.6852 6.69012 14.9802 6.45413L14.6168 6ZM13.2746 10.0263L12.7907 10.3489C13.069 10.7663 13.4144 11.0561 13.8158 11.1971C14.2171 11.3381 14.6171 11.3103 14.9684 11.1932C15.6449 10.9677 16.2002 10.3968 16.4791 9.83903L15.9589 9.57895L15.4387 9.31886C15.2702 9.65583 14.9307 9.97967 14.6006 10.0897C14.4485 10.1404 14.3173 10.1405 14.2013 10.0997C14.0854 10.059 13.9276 9.95735 13.7585 9.70374L13.2746 10.0263Z" fill="currentColor" />;
    t8 = <circle cx="14" cy="15" r="9" stroke="currentColor" strokeWidth="1.3" />;
    t9 = <path d="M23 12.1089C23.7818 11.7557 25.4079 12.2169 25.658 14.1542C25.9082 16.0915 24.1841 17.5 23 17.1" stroke="currentColor" strokeWidth="1.16316" strokeLinejoin="round" />;
    t10 = <path d="M5 12.0002C4.21822 11.6471 2.27462 12.2169 2.02445 14.1542C1.77428 16.0915 3.49841 17.5 4.6825 17.1001" stroke="currentColor" strokeWidth="1.16316" strokeLinejoin="round" />;
    t11 = <circle cx="11.1579" cy="14.0529" r="0.447368" fill="black" stroke="currentColor" strokeWidth="0.894737" />;
    t12 = <circle cx="17.4209" cy="14.0529" r="0.447368" fill="black" stroke="currentColor" strokeWidth="0.894737" />;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  let t13;
  if ($[9] !== t3 || $[10] !== t5) {
    t13 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}{t10}{t11}{t12}</svg>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  return t13;
};
export default PediatricsIcon;